import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';

import backgroundImage from '../assets/images/reward/bg.jpg'
import continueBtn from '../assets/images/reward/continue.png'

class Reward extends Component {
    btnSound = './sounds/button_sound.mp3';

    playBtnSound() {
        let btnAudio = new Audio(this.btnSound);
        btnAudio.play();
    }

    goToIntroPage() {
        this.playBtnSound();
        this.props.history.push({
            pathname: './intro',
            state: {}
        });
    }

    render() {
        return (
            <div className='page-root-div'>
                <img alt='' src={backgroundImage} style={{ width: '100%', height: '100%', overflow: 'hidden', objectFit: 'cover', position: 'absolute' }}/>
                <img alt='' className='press-btn' src={continueBtn} style={{ position: 'absolute', height: '11.5%', left: '41%', bottom: '8.8%' }} onClick={this.goToIntroPage.bind(this)}/>
            </div>
        )
    }
}

export default withRouter(Reward);
